import { render, staticRenderFns } from "./MessagesMainPanel.vue?vue&type=template&id=2346cc8f"
import script from "./MessagesMainPanel.vue?vue&type=script&lang=js"
export * from "./MessagesMainPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports